import { AutoTextarea, Field } from "./shared";

const SCORE_HINT = ["0 · Absent", "1 · Inapproprié", "2 · Base insuffisante", "3 · Compétent avec lacunes", "4 · Compétent", "5 · Très compétent", "6 · Expert"];
const scoreColor = (s) => (s == null ? "bg-muted text-muted-foreground" : s >= 4 ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300" : s >= 2 ? "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300" : "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300");

export const CtsrForm = ({ data, onChange, specs, config }) => {
  const itemsSpec = specs[config.items];
  const items = data.items || {};
  const setItem = (k, patch) => onChange({ ...data, items: { ...items, [k]: { ...(items[k] || {}), ...patch } } });
  const scored = itemsSpec.map((i) => items[i.key]?.score).filter((s) => s != null);
  const total = scored.reduce((a, b) => a + b, 0);
  const n = itemsSpec.length;
  return (
    <div className="space-y-4" data-testid="ctsr-form">
      <div className="flex items-center justify-between flex-wrap gap-2 rounded-xl border bg-muted/30 px-4 py-2">
        <div className="text-sm"><span className="font-semibold">Score</span> <span className="text-muted-foreground">({scored.length}/{n} items notés)</span></div>
        <div className="text-sm font-semibold" data-testid="ctsr-total">{scored.length ? `${total} / ${scored.length * 6}` : "—"} {scored.length > 0 && <span className="text-muted-foreground font-normal">· moyenne {(total / scored.length).toFixed(1)}</span>}</div>
      </div>
      <div className="space-y-2">
        {itemsSpec.map((it, idx) => {
          const v = items[it.key] || {};
          return (
            <div key={it.key} className="rounded-xl border p-3 grid md:grid-cols-[220px_1fr_1fr] gap-3 items-start" data-testid={`ctsr-item-${it.key}`}>
              <div className="space-y-2">
                <div className="text-sm font-medium">{idx + 1}. {it.label}</div>
                <select className={`text-xs rounded-lg border border-border px-2 py-1.5 ${scoreColor(v.score)}`} value={v.score ?? ""} onChange={(e) => setItem(it.key, { score: e.target.value === "" ? null : Number(e.target.value) })} data-testid={`ctsr-score-${it.key}`}>
                  <option value="">Non noté</option>
                  {SCORE_HINT.map((h, s) => <option key={s} value={s}>{h}</option>)}
                </select>
              </div>
              <AutoTextarea value={v.observation} onChange={(x) => setItem(it.key, { observation: x })} placeholder="Observation (exemple concret de la séance)…" rows={2} testId={`ctsr-obs-${it.key}`} />
              <AutoTextarea value={v.suggestion} onChange={(x) => setItem(it.key, { suggestion: x })} placeholder="Piste d'amélioration…" rows={2} className="italic" testId={`ctsr-sugg-${it.key}`} />
            </div>
          );
        })}
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <Field label="Points forts du thérapeute"><AutoTextarea value={data.strengths} onChange={(v) => onChange({ ...data, strengths: v })} rows={4} testId="ctsr-strengths" /></Field>
        <Field label="Axes de développement"><AutoTextarea value={data.improvements} onChange={(v) => onChange({ ...data, improvements: v })} rows={4} testId="ctsr-improvements" /></Field>
      </div>
      <Field label="Auto-réflexion du thérapeute" hint="Questions proposées par l'IA puis vos réponses / réflexions">
        <AutoTextarea value={data.self_reflection} onChange={(v) => onChange({ ...data, self_reflection: v })} rows={5} className="border-primary/40 bg-primary/5" testId="ctsr-self-reflection" />
      </Field>
    </div>
  );
};
